<template>
    <Button
        size="xl"
        :interfaceTarget="props.interfaceTarget"
        :label="isLoading ? $tr('gameContainer.warming_up') : props.label"
        :class="[
            $style.play_button_override,
            isLoading && $style.loading_override,
            props.pressed && $style.pressed_override,
        ]"
        @click="emit('click')"
    />
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'

import Button from '@/components/Buttons/Button.vue'

// Keep in sync with CSS animation duration in .loading_override::after
const LOADER_DURATION_MS = 700

const emit = defineEmits<{
    click: []
}>()

const props = defineProps<{
    label: string
    interfaceTarget: string
    withLoader?: boolean
    pressed?: boolean
}>()

const isLoading = ref(props.withLoader)

onMounted(() => {
    if (props.withLoader) {
        setTimeout(() => {
            isLoading.value = false
        }, LOADER_DURATION_MS)
    }
})
</script>
<style module>
.play_button_override {
    container-type: inline-size;
    --play-button-gradient:
        radial-gradient(40.49% 80.01% at 50% 99.41%, rgba(227, 127, 255, 0.56) 0%, rgba(146, 64, 252, 0.8) 100%),
        var(--purple-400);
    height: 64px;
    flex-shrink: 0;
}

.play_button_override * {
    font-weight: var(--font-weight-bold);
    font-size: 23px; /* Fallback for browsers without container queries */
    margin-top: -2px;
}

@supports (font-size: 1cqw) {
    .play_button_override * {
        font-size: clamp(12px, 10cqi, 23px);
    }
}

.play_button_override::before {
    content: '';
    position: absolute;
    background: var(--play-button-gradient);
    box-shadow: 0 1px 2px 0 rgba(216, 153, 255, 0.5) inset;
}

.play_button_override:active,
.pressed_override {
    filter: brightness(0.85);
}

.loading_override::before {
    background: transparent;
    box-shadow: none;
}

.loading_override {
    border: 1px solid var(--white-12);
}

.loading_override > * {
    z-index: 1;
    color: var(--white-40);
}

.loading_override::after {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--play-button-gradient);
    animation: progress 700ms linear forwards;
    border-radius: inherit;
}

@keyframes progress {
    0% {
        clip-path: inset(0 100% 0 0);
    }
    70% {
        clip-path: inset(0 50% 0 0);
    }
    100% {
        clip-path: inset(0 0 0 0);
    }
}
</style>
